import Dropdown from 'components/Dropdown/Dropdown';

function LenderDropdown({ selected, onChange, lendersList }) {
	return (
		<Dropdown
			label="Lenders"
			items={['All', ...lendersList.map(({ lenderName }) => lenderName)]}
			selected={selected}
			onChange={onChange}
		/>
	);
}

export default LenderDropdown;
